import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { universalHeaderId } from '@scentregroup/shared/constants';
export function getStickyHeaderHeight(siteHeadersIds) {
  const headers = siteHeadersIds && document.getElementById(siteHeadersIds) || document.getElementById(universalHeaderId);
  const isHeaderSticky = headers && window.getComputedStyle(headers).position === 'sticky';
  return isHeaderSticky ? headers === null || headers === void 0 ? void 0 : headers.getBoundingClientRect().height : 0;
}
const scrollIntoView = id => {
  const element = document.getElementById(id);
  if (element && typeof window.scrollTo === 'function') {
    const top = element.offsetTop - getStickyHeaderHeight();
    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  }
};
export const scrollToFirstError = function (errors, scrollToMappings) {
  let scrollFunction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : scrollIntoView;
  const errorKeys = Object.keys(errors);
  for (let i = 0; i < errorKeys.length; i++) {
    const error = errorKeys[i];
    if (errors[error]) {
      scrollFunction(scrollToMappings[error]);
      break;
    }
  }
};
const getActiveElement = () => document.activeElement;
export const blurActiveAndGetFinalValues = function (values) {
  let getActiveElementFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getActiveElement;
  const activeElement = getActiveElementFn();
  const valuesOnSubmit = _objectSpread({}, values);
  if (activeElement && typeof activeElement.blur === 'function') {
    activeElement === null || activeElement === void 0 || activeElement.blur();
  }
  return valuesOnSubmit;
};